import Vue from 'vue'
import Vuex from 'vuex'

import users from './users'
import events from './events'
import locations from './locations'

const fb = require('../firebaseConfig.js');

Vue.use(Vuex)

const state = {
  db: fb.firebase.firestore(), 
  firebase: fb.firebase
}

export default new Vuex.Store({
  state,
  modules: {
    users, events, locations
  }
})